module.exports = __webpack_public_path__ + "89a387626208d7730083f2cf84b3d1b2.png";